import React, { useState } from "react";
import Bp from "../../assests/images/b_p.png";
import Bo from "../../assests/images/b_o.png";
import Gm from "../../assests/images/g_m.png";
import Hr from "../../assests/images/h_r.png";
import sleep from "../../assests/images/sleep.png";
import Bt from "../../assests/images/b_t.png";
import water from "../../assests/images/water.png";
import weight from "../../assests/images/weight.png";
import Rr from "../../assests/images/r_r.png";
import { useSaveLogTrackerMutation } from "../../redux/service/trackers_service";
import { toast } from "react-toastify";
import { getUser } from "../../userStore";
import DatePicker from "react-datepicker";
import moment from "moment";
import LoadingBar from "../../components/LoadingBar";
import MainPageDialog from "../../components/mainPageDialog";
import { hasActionRights } from "../../userStore";
const TrackerCard = ({ title, threshold, name, setSelectedCard, ...other }) => {
  //make state for threshold ,and save value in details object ,multple threshold can be added as an array of object,value and title will be saved in details object
  const [thresholdValue, setThresholdValue] = useState({
    details: [],
    date: moment().format("MM/DD/YYYY HH:mm "),
  });
  const [commentsDaialog, setCommentsDialog] = useState({
    show: false,
    comments: "",
  });
  //save threshold value
  const [saveLogTracker, { isLoading }] = useSaveLogTrackerMutation();
  const saveThreshold = async (e) => {
    e.preventDefault();
    const payload = {
      ...thresholdValue,
      tracker_id: other.id,
      log_time: thresholdValue.date,
      pid: getUser()?.pid,
      savingTracker: true,
    };
    const result = await saveLogTracker({ ...payload });
    if (result.error) {
      toast.error("Failed to save: " + result.error);
    } else if (result.data?.response?.code === 0) {
      setThresholdValue({
        details: [],
        date: moment().format("MM/DD/YYYY HH:mm"),
      });
      toast.success("Saved successfully");
    } else {
      toast.error("Failed to save: " + result.data?.response?.msg);
    }
  };

  // return image according to the name of the tracker
  const getImage = (name) => {
    switch (name) {
      case "blood_pressure":
        return Bp;
      case "blood_oxygen":
        return Bo;
      case "glucose":
        return Gm;
      case "heart_rate":
        return Hr;
      case "sleep":
        return sleep;
      case "body_temperature":
        return Bt;
      case "water":
        return water;
      case "weight":
        return weight;
      case "respiratory_rate":
        return Rr;
      default:
        return Bp;
    }
  };

  return (
    <>
      {commentsDaialog.show && (
        <MainPageDialog
          title="Instruction"
          modalSize="md"
          maxHeight={true}
          footerList={[
            {
              title: "Cancel",
              type: "cancel",
              action: () =>
                setCommentsDialog({
                  show: false,
                  comments: "",
                }),
            },
          ]}
          onCancelHandler={() =>
            setCommentsDialog({
              show: false,
              comments: "",
            })
          }
        >
          {commentsDaialog?.comments}
        </MainPageDialog>
      )}
      <li
        className={`col-span-1 ${
          isLoading && "animate-pulse"
        } divide-y divide-gray-200 rounded-lg bg-white shadow-md bg-[#f9f9f9] border-solid border-2 border-[#cccccc]`}
      >
        {isLoading  && 
          <LoadingBar/>
        }
        <form onSubmit={saveThreshold}>
          <div className=" w-full items-center justify-between p-6">
            <div className="flex gap-1 items-center justify-center">
              <img src={getImage(name)} alt="bp" className="w-10 h-10" />
              <h2 className="text-xl font-bold mb-2">{title}</h2>
            </div>
            <div className="flex gap-2 h-20 mt-4 items-center content-center justify-center w-full">
              {threshold.map((field, index) => (
                <div
                  key={field.label}
                  class="flex items-center border-b border-teal-500 py-2"
                >
                  <input
                    class="appearance-none bg-transparent border-none w-full text-gray-700 mr-3 py-1 px-2 leading-tight focus:outline-none"
                    type="text"
                    value={thresholdValue.details[index]?.value || ""}
                    placeholder={field.title}
                    onChange={(e) => {
                      ///save on index base
                      let temp = [...thresholdValue.details];
                      temp[index] = {
                        value: e.target.value,
                        title: field.title,
                        value_id: 0,
                        error: "",
                      };
                      setThresholdValue({ ...thresholdValue, details: temp });
                    }}
                    required
                    aria-label="Full name"
                  ></input>
                </div>
              ))}
              <p className="font-bold">{other.unit}</p>
            </div>

            <div className="mt-4">
              <DatePicker
                dateFormat={"MM/DD/YYYY HH:mm"}
                className="w-full border border-gray-300 rounded-md p-1"
                showTimeInput={true}
                onChange={(e) => {
                  setThresholdValue({
                    ...thresholdValue,
                    date: moment(e).format("MM/DD/YYYY HH:mm"),
                  });
                }}
                value={thresholdValue.date}
              />
            </div>
              <div className="flex justify-between mt-1">
                <div>
                {other?.instructions && <p className="btn btn-primary  underline text-sky-600 cursor-pointer" 
                   onClick={() => 
                   setCommentsDialog({
                    show: true,
                    comments: other?.instructions,
                  })}>Instructions</p>
                }
                </div>
                <p
                className="btn btn-primary  underline text-sky-600 cursor-pointer hover:text-sky-700"
                onClick={() => setSelectedCard({ title: title, ...other })}
              >
                View History
              </p>
              </div>
            {hasActionRights('trackers','add')==1&&<button
              type="submit"
              disabled={isLoading}
              class="mt-2 w-full bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 border border-blue-700 rounded"
            >
              Save
            </button>}
          </div>
        </form>
      </li>
    </>
  );
};

export default TrackerCard;
